const DAYS_MAP = {
    "monday": "1",
    "tuesday": "2",
    "wednesday": "3",
    "thursday": "4",
    "friday": "5",
    "saturday": "6",
    "sunday": "7"
};

export const getIntervalDayHourValues = () => {
    let val = "";
    const trs = document.querySelectorAll(".modalBody tr.trWeek");

    console.log(`[getIntervalDayHourValues] Iniciando lectura del DOM. Filas '.trWeek' encontradas: ${trs.length}`);

    if (!trs.length) {
        console.warn("[getIntervalDayHourValues] No se encontraron filas '.trWeek' en el modal.");
        return val;
    }

    trs.forEach((_, i) => {

        console.log(`%c[Fila ${i}] --- Procesando días ---`, 'color: #007bc0; font-weight: bold;');

        const tds = document.querySelectorAll(".weekDay-" + i);

        tds.forEach((td, tdIdx) => {
            const firstChild = td?.children?.[0];
            const name = firstChild?.getAttribute("name");
            const value = firstChild?.value;

            if (value === "true" && name && DAYS_MAP[name]) {

                console.log(`   -> [Día Detectado] Fila: ${i}, Columna TD: ${tdIdx}, Nombre: '${name}' es TRUE. Mapea a ID: ${DAYS_MAP[name]}`);
                val += DAYS_MAP[name] + ",";
            }
        });

        if (val.endsWith(",")) {
            val = val.substring(0, val.length - 1);
        }
        val += ";";

        console.log(`%c[Fila ${i}] --- Procesando horas ---`, 'color: #5f259f;');
        const tdsIntervalTime = document.querySelectorAll(".timeInterval-" + i);

        tdsIntervalTime.forEach((tdIntervalTime, timeIdx) => {
            const hour = tdIntervalTime?.children?.[0]?.value || "";
            const minute = tdIntervalTime?.children?.[1]?.value || "";

            console.log(`   -> [Hora Detectada] Fila: ${i}, Selector index: ${timeIdx}, Tiempo: ${hour}:${minute}`);
            val += hour + ":" + minute + "-";
        });
        console.log(`[Fila ${i}] Estado parcial del string acumulado: "${val}"`);
    });

    console.log(`%c[getIntervalDayHourValues] Proceso terminado. String final generado: "${val}"`, 'color: #4caf50; font-weight: bold;');
    return val;
};